import {
  WEBCAM_ERROR_DURATION_LOCALSTORAGE_KEY,
  WEBCAM_ERROR_START_TIME_LOCALSTORAGE_KEY,
} from '../constants/Proctor';
import { errorLogger } from './trackingUtil';

export function normalizeTimerSeconds(value) {
  const parsedSeconds = typeof value === 'string' ? parseFloat(value) : value;
  return Number.isFinite(parsedSeconds) ? parsedSeconds : null;
}

export function ensureWebcamErrorDurationInitialized() {
  try {
    console.log('webcam initialized');
    const storedDurationSeconds = localStorage.getItem(
      WEBCAM_ERROR_DURATION_LOCALSTORAGE_KEY
    );
    if (storedDurationSeconds === null) {
      localStorage.setItem(WEBCAM_ERROR_DURATION_LOCALSTORAGE_KEY, '0');
    }
  } catch (error) {
    // non-fatal (storage may be blocked)
    errorLogger(error);
  }
}

export function startWebcamErrorClock(nowMs) {
  try {
    console.log('webcam start');
    const storedStartTimeMs = localStorage.getItem(
      WEBCAM_ERROR_START_TIME_LOCALSTORAGE_KEY
    );
    const didStartNewIncident = !storedStartTimeMs;
    const incidentStartTimeMs = storedStartTimeMs
      ? parseInt(storedStartTimeMs, 10)
      : nowMs;
    if (didStartNewIncident) {
      localStorage.setItem(
        WEBCAM_ERROR_START_TIME_LOCALSTORAGE_KEY,
        String(nowMs)
      );
    }
    ensureWebcamErrorDurationInitialized();
    return { startedNew: didStartNewIncident, startMs: incidentStartTimeMs };
  } catch (error) {
    errorLogger(error);
    return { startedNew: false, startMs: null };
  }
}

export function stopWebcamErrorClockAndAccumulate(nowMs) {
  try {
    console.log('webcam stop');
    const storedStartTimeMs = localStorage.getItem(
      WEBCAM_ERROR_START_TIME_LOCALSTORAGE_KEY
    );
    const incidentStartTimeMs = storedStartTimeMs
      ? parseInt(storedStartTimeMs, 10)
      : NaN;
    if (!Number.isFinite(incidentStartTimeMs)) {
      localStorage.removeItem(WEBCAM_ERROR_START_TIME_LOCALSTORAGE_KEY);
      return null;
    }

    const incidentElapsedSeconds = Math.max(
      0,
      (nowMs - incidentStartTimeMs) / 1000
    );
    const storedDurationSeconds = localStorage.getItem(
      WEBCAM_ERROR_DURATION_LOCALSTORAGE_KEY
    );
    const previousDurationSeconds = storedDurationSeconds
      ? parseFloat(storedDurationSeconds)
      : 0;
    const nextDurationSeconds = Math.floor(
      previousDurationSeconds + incidentElapsedSeconds
    );

    localStorage.setItem(
      WEBCAM_ERROR_DURATION_LOCALSTORAGE_KEY,
      String(nextDurationSeconds)
    );
    localStorage.removeItem(WEBCAM_ERROR_START_TIME_LOCALSTORAGE_KEY);
    return {
      nextDurationSec: nextDurationSeconds,
      incidentDurationSec: Math.floor(incidentElapsedSeconds),
    };
  } catch (error) {
    errorLogger(error);
    return null;
  }
}

export function getWebcamErrorStartTimeMs() {
  try {
    const storedStartTimeMs = localStorage.getItem(
      WEBCAM_ERROR_START_TIME_LOCALSTORAGE_KEY
    );
    const incidentStartTimeMs = storedStartTimeMs
      ? parseInt(storedStartTimeMs, 10)
      : NaN;
    return Number.isFinite(incidentStartTimeMs) ? incidentStartTimeMs : null;
  } catch (error) {
    errorLogger(error);
    return null;
  }
}

export function getWebcamErrorDurationSeconds() {
  try {
    const storedDurationSeconds = localStorage.getItem(
      WEBCAM_ERROR_DURATION_LOCALSTORAGE_KEY
    );
    const durationSeconds = storedDurationSeconds
      ? parseFloat(storedDurationSeconds)
      : 0;
    return Number.isFinite(durationSeconds) ? durationSeconds : 0;
  } catch (error) {
    errorLogger(error);
    return 0;
  }
}

// Clears the current "incident" start time without accumulating into duration.
// Useful when strict-camera enforcement is not allowed to run (e.g., system checks / pre-start).
export function clearWebcamErrorStartTime() {
  try {
    localStorage.removeItem(WEBCAM_ERROR_START_TIME_LOCALSTORAGE_KEY);
  } catch (error) {
    // non-fatal
    errorLogger(error);
  }
}

export function clearWebcamErrorStartTimeDuration() {
  try {
    localStorage.removeItem(WEBCAM_ERROR_START_TIME_LOCALSTORAGE_KEY);
    localStorage.removeItem(WEBCAM_ERROR_DURATION_LOCALSTORAGE_KEY);
  } catch (error) {
    // non-fatal
    errorLogger(error);
  }
}
